import { createStyles, StyledComponentProps, withStyles } from '@material-ui/core/styles';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { OcDataview } from '../../comps/OcDataview';
import { OcDataviewFiltering } from '../../comps/OcDataviewFiltering';
import { PleaseWait } from '../../comps/PleaseWait';
import { mg } from '../../mg/mg';
import { commSvc } from '../../services/CommSvc';
import { DataviewStore } from '../../stores/DataviewStore';
import { getOmnistore } from '../../stores/Omnistore';
import { OcScreen } from '../OcScreen';
import { MessageDetailDialog } from './MessageDetailDialog';

const dataviewStore = DataviewStore.create({
	id: 'MessageList',
	orgColumns: [
		'isRead :bool 35',
		'creationTimestamp :datetime 50',
		'branchName',
		'type :Message_Type',
		'subject',
		'text',
		'parameter',
		'id :int 50',
	],
	sorting: {column: 'creationTimestamp', reversed: true},
	highlighting: '!isRead',
	filtering: [
		{columns: ['branchName'], type: 'SELECT'},
		// {columns: ['type'], type: 'SELECT'}, //TODO
	],
});

dataviewStore.addColumnHiderToNamed('DEFAULT', 'text', 'isRead');
dataviewStore.addColumnHiderToNamed('FIXED', 'branchName');
dataviewStore.addColumnHiderToNamed('HIDDEN', 'id', 'parameter');

@observer class _MessagePage extends OcScreen<StyledComponentProps> {
	@computed get _isFiltered() {
		return false;
	}

	@computed get _etag() {
		const multirepo = getOmnistore().multirepo;
		const m = multirepo.messageRepo.etag;
		if (!m) return '';
		const t = multirepo.templateRepo.etag;
		if (!t && this._isFiltered) return '';
		const b = multirepo.branchRepo.etag;
		return m + '/' + t + '/' + b;
	}

	@computed get _allAsList() {
		const multirepo = getOmnistore().multirepo;
		const locationStore = getOmnistore().locationStore;
		const templates = multirepo.templateRepo.allAsList.filter(t => !this._isFiltered || t.branchId == locationStore.branchId);
		const templateMap = mg.entriesToObject(templates.map(t => [t.id, t]));
		return multirepo.messageRepo.allAsList
			.map(e => {
				const t = templateMap[e.parameter];
				if (!t && this._isFiltered) return null;
				const b = !t ? null : multirepo.branchRepo.byId(t.branchId);
				return Object.assign({}, e, {branchName: !b ? '-' : b.name});
			})
			.filter(mg.isPresent);
	}

	@computed get _repo() {
		return {
			etag: this._etag,
			allAsList: this._allAsList,
		};
	}

	// intentionally not @observable
	_lastSelectedEntityId = 0

	autoruns() {
		const multirepo = getOmnistore().multirepo;
		const messageRepo = multirepo.messageRepo;
		return [
			() => {
				dataviewStore.setIgnoredColumnHiders([
					!this._isFiltered ? 'FIXED' : null,
				]);
			},
			() => {
				const id = dataviewStore.selectedEntityId;
				if (id === this._lastSelectedEntityId) return;
				this._lastSelectedEntityId = id;
				const e = messageRepo.byId(id);
				if (!e) return;
				commSvc.doPost('UpdateMessage', {...e, isRead: true})
					.then(r => messageRepo.fetchDirect());
			},
		];
	}

	name() {
		return 'MessagePage';
	}

	submenu() {
		const locationStore = getOmnistore().locationStore;
		return [
			<OcDataviewFiltering key="filtering" state={dataviewStore} repo={this._repo}/>,
		];
	}

	usedStores = () => ['Message', 'Template', 'Branch', 'Advertisement']

	_onDialogClose = () => dataviewStore.rowClick(0)

	renderBody() {
		if (!this._repo.etag) return <PleaseWait/>;
		const multirepo = getOmnistore().multirepo;
		const messageRepo = multirepo.messageRepo;
		return <React.Fragment>
			<OcDataview repo={this._repo} state={dataviewStore}/>
			<MessageDetailDialog entity={messageRepo.byId(dataviewStore.selectedEntityId)} onClose={this._onDialogClose}/>
		</React.Fragment>;
	}
}

const styles = createStyles({
});

export const MessagePage = withStyles(styles)(_MessagePage);
